<div>
    <app-tool-bar [title]="'Manage Transports'" [iconName]="'pi-car'" [isAdd]="true"
        (handleAdd)="handleTransport()"></app-tool-bar>
</div>
<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
        [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">
                    S.No
                </th>
                <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : ''">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
                <td>
                    <div style="margin-left: 5px;">
                        {{ rowIndex + 1 }}
                    </div>
                </td>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">

                        <ng-container *ngSwitchCase="'fee_amount'">
                            {{ rowData[col.field] | currency: rowData.currency }}
                        </ng-container>

                        <!-- Array Type (for amenities) -->
                        <ng-container *ngSwitchCase="'array'">
                            <div class="flex flex-wrap gap-1">
                                <span *ngFor="let item of getNestedValue(rowData, col.field)" 
                                      class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                                    {{ item }}
                                </span>
                            </div>
                        </ng-container>

                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setTransportEditData(rowData)">
                                <p-menu [tabindex]="undefined" #menu [model]="TransportActionItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"
                                    class="p-button-rounded p-button-text"></button>
                            </div>
                        </ng-container>

                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ getNestedValue(rowData, col.field) }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- when data length is 0 -->

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>

<p-dialog [modal]="true" *ngIf="isAddTransport" [(visible)]="isAddTransport"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '50vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-transport (closeDialog)="isAddTransport = false"
        (reload)="reloadData()"></app-create-transport>
</p-dialog>


<p-dialog [modal]="true"
*ngIf="isEditTransport"
[(visible)]="isEditTransport" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <app-create-transport (closeDialog)="isEditTransport = false" [type]="'Update'"
    [transportData]="transportData"
        (reload)="reloadData()"></app-create-transport>
</p-dialog>


<p-dialog [modal]="true"
*ngIf="isDeleteTransport"
[(visible)]="isDeleteTransport" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">

    <app-delete-transport (closeDialog)="isDeleteTransport = false"
    [transportData]="transportData"
        (reload)="reloadData()"></app-delete-transport>

</p-dialog>
